var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnInit } from "@angular/core";
import { CandidateEntityModel } from "app/interfaces/candidate-entity.model";
import { TagsService } from "app/services";
import { FeatureFlagService } from "app/services/feature-flag.service";
import { FeatureFlags } from "feature-flags";
var CandidateCardComponent = /** @class */ (function () {
    function CandidateCardComponent(tagsService, ffs) {
        var _this = this;
        this.tagsService = tagsService;
        this.ffs = ffs;
        this.openDetail = new EventEmitter();
        this.sendMessageSelection = new EventEmitter();
        this.addTag = new EventEmitter();
        this.removeTag = new EventEmitter();
        this.changeStatus = new EventEmitter();
        this.changeProcessStatus = new EventEmitter();
        this.progress = 0;
        this.value = null;
        this.isScoreDisabledFF = this.ffs.isEnabled(FeatureFlags.DISABLE_SCORE) || false;
        this.deleteTagService = function (args) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this._deleteTag(args)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.createTagService = function (args) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this._createTag(args)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.ffs.unleash.on("update", function () {
            _this.isScoreDisabledFF = _this.ffs.isEnabled(FeatureFlags.DISABLE_SCORE);
        });
    }
    Object.defineProperty(CandidateCardComponent.prototype, "scoreEnabled", {
        get: function () {
            return "user_score" in this.candidate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CandidateCardComponent.prototype, "preferredLocationEnabled", {
        get: function () {
            return "preferred_location" in this.candidate && this.candidate.preferred_location !== null;
        },
        enumerable: true,
        configurable: true
    });
    CandidateCardComponent.prototype.ngOnInit = function () {
        if (this.candidate.user_score && this.candidate.user_score > 0) {
            this.progress = 198 * (1 - this.candidate.user_score);
            this.value = Math.round(this.candidate.user_score * 100);
        }
    };
    CandidateCardComponent.prototype.emitOpenDetail = function () {
        this.openDetail.emit(this.candidate);
    };
    CandidateCardComponent.prototype.onTagClick = function (data) {
        this.tagsService
            .putCurriculaTagByApplicationId(this.candidate.id, {
            id: data.id,
            value: data.name,
        })
            .subscribe();
    };
    CandidateCardComponent.prototype._deleteTag = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.tagsService
                            .deleteCurriculaTagByApplicationId(this.candidate.id, args)
                            .toPromise()];
                    case 1:
                        _b.sent();
                        _a = this.candidate;
                        return [4 /*yield*/, this.tagsService
                                .getCurriculaTagsByApplicationId(this.candidate.id)
                                .toPromise()];
                    case 2:
                        _a.tags = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CandidateCardComponent.prototype._createTag = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.tagsService
                            .putCurriculaTagByApplicationId(this.candidate.id, { value: args })
                            .toPromise()];
                    case 1:
                        _b.sent();
                        _a = this.candidate;
                        return [4 /*yield*/, this.tagsService
                                .getCurriculaTagsByApplicationId(this.candidate.id)
                                .toPromise()];
                    case 2:
                        _a.tags = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CandidateCardComponent.prototype.emitChangeProcessStatus = function (processStatus) {
        this.changeProcessStatus.emit(processStatus);
    };
    return CandidateCardComponent;
}());
export { CandidateCardComponent };
